@if (notice(); as notice) {
  <div class="cart-update-notice" role="alert">
    <i class="pi pi-info-circle cart-update-notice__icon"></i>
    <div class="cart-update-notice__body">
      <p class="cart-update-notice__title">Your cart was updated</p>
      <p class="cart-update-notice__reason">{{ notice }}</p>
    </div>
    <button
      type="button"
      class="cart-update-notice__close"
      (click)="dismiss()"
      aria-label="Dismiss cart update notice"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>
}
